import { createSlice } from '@reduxjs/toolkit';

const initialState = {

  employeeScheduleTemplateList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    error: null,
    success: false,
    filters: {},
  },
  employeeScheduleTemplateDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
};

export const employeeScheduleTemplateSlice = createSlice({
  name: 'employeeScheduleTemplate',
  initialState,
  reducers: {

    getEmployeeScheduleTemplateList: (state, action) => {
      state.employeeScheduleTemplateList.requesting = true;
      state.employeeScheduleTemplateList.error = null;
      state.employeeScheduleTemplateList.items = [];
      state.employeeScheduleTemplateList.success = false;
      state.employeeScheduleTemplateList.filters = action.payload;
    },

    getEmployeeScheduleTemplateListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload;
      state.employeeScheduleTemplateList.requesting = false;
      state.employeeScheduleTemplateList.items = data;
      state.employeeScheduleTemplateList.success = true;
      state.employeeScheduleTemplateList.pagination.current_page = current_page;
      state.employeeScheduleTemplateList.pagination.per_page = per_page;
      state.employeeScheduleTemplateList.pagination.total = total;
    },

    getEmployeeScheduleTemplateListFail: (state, action) => {
      state.employeeScheduleTemplateList.requesting = false;
      state.employeeScheduleTemplateList.error = action.payload;
    },

    getEmployeeScheduleTemplateDetails: (state) => {
      state.employeeScheduleTemplateDetails.requesting = true;
      state.employeeScheduleTemplateDetails.error = null;
      state.employeeScheduleTemplateDetails.data = null;
      state.employeeScheduleTemplateDetails.success = false;
    },

    getEmployeeScheduleTemplateDetailsSuccess: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.data = action.payload;
      state.employeeScheduleTemplateDetails.success = true;
    },

    getEmployeeScheduleTemplateDetailsFail: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.error = action.payload;
    },

    doEmployeeScheduleTemplateCreate: (state) => {
      state.employeeScheduleTemplateDetails.requesting = true;
      state.employeeScheduleTemplateDetails.error = null;
      state.employeeScheduleTemplateDetails.data = null;
      state.employeeScheduleTemplateDetails.success = false;
    },

    doEmployeeScheduleTemplateCreateSuccess: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.data = action.payload;
      state.employeeScheduleTemplateDetails.success = true;
    },

    doEmployeeScheduleTemplateCreateFail: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.error = action.payload;
      state.employeeScheduleTemplateDetails.success = false;
    },

    doEmployeeScheduleTemplateUpdate: (state) => {
      state.employeeScheduleTemplateDetails.requesting = true;
      state.employeeScheduleTemplateDetails.error = null;
      state.employeeScheduleTemplateDetails.data = null;
      state.employeeScheduleTemplateDetails.success = false;
    },

    doEmployeeScheduleTemplateUpdateSuccess: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.data = action.payload;
      state.employeeScheduleTemplateDetails.success = true;
    },

    doEmployeeScheduleTemplateUpdateFail: (state, action) => {
      state.employeeScheduleTemplateDetails.requesting = false;
      state.employeeScheduleTemplateDetails.error = action.payload;
      state.employeeScheduleTemplateDetails.success = false;
    },

    doEmployeeScheduleTemplateDelete: (state) => {
      state.employeeScheduleTemplateDetails.requesting = true;
      state.employeeScheduleTemplateDetails.error = null;
      state.employeeScheduleTemplateDetails.data = null;
      state.employeeScheduleTemplateDetails.success = false;
    },

    doEmployeeScheduleTemplateReset: (state) => {
      state.employeeScheduleTemplateDetails.data = null;
    },
  },
});

export const {
  getEmployeeScheduleTemplateList, getEmployeeScheduleTemplateListSuccess,
  getEmployeeScheduleTemplateListFail, getEmployeeScheduleTemplateDetails,
  getEmployeeScheduleTemplateDetailsSuccess, getEmployeeScheduleTemplateDetailsFail,
  doEmployeeScheduleTemplateCreate, doEmployeeScheduleTemplateCreateSuccess,
  doEmployeeScheduleTemplateCreateFail, doEmployeeScheduleTemplateUpdate,
  doEmployeeScheduleTemplateUpdateSuccess, doEmployeeScheduleTemplateUpdateFail,
  doEmployeeScheduleTemplateDelete, doEmployeeScheduleTemplateReset,
} = employeeScheduleTemplateSlice.actions;

export default employeeScheduleTemplateSlice.reducer;